// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as AuthStore$PorterinFeature from "../store/AuthStore.mjs";
import * as SignupApiModel$PorterinFeature from "../api-model/SignupApiModel.mjs";

function apiModelToState(_model) {
  return {
          message: AuthStore$PorterinFeature.response_signup_success
        };
}

function execute(json) {
  DeccoUtils$Catalyst.resolveResult(SignupApiModel$PorterinFeature.t_decode(json), "SignupEntityMapper.res");
  return {
          message: AuthStore$PorterinFeature.response_signup_success
        };
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
